import { render, staticRenderFns } from "./graphTeamComp.vue?vue&type=template&id=65142a5a&scoped=true&"
import script from "./graphTeamComp.vue?vue&type=script&lang=js&"
export * from "./graphTeamComp.vue?vue&type=script&lang=js&"
import style0 from "./graphTeamComp.vue?vue&type=style&index=0&id=65142a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65142a5a",
  null
  
)

export default component.exports